import { updateCategoryType } from '@/plugins/dataLayer/utils/index.js';

export default function($store) {
  return {
    name: {
      ugc: 'UGC Flow',
      checkerboarder: 'UGC Flow - Checkerboarder',
      imageLibrary: 'UGC Flow - Image Library',
      crayola: 'Crayola'
    },
    event: {
      name: 'trackEvent',
      nameIframe: 'loadEventData',
      category: 'Customs',
      customMetrics: {},
      customVariables: {},
      _clear: true,
      nonInteractive: false
    },
    types: {
      start: 'start',
      acceptTerms: 'accept terms',
      applyDesign: 'Image Upload Accepted',
      applyEdits: 'apply edits and position',
      chooseImage: 'Choose Image',
      addYourImage: 'Add Your Image',
      uploadError: 'Image Upload Rejected',
      uploadSuccess: 'Image Upload Accepted',
      selectStyle: ' - Select Style',
      selectSize: ' - Select Size',
      closeModal: 'Close Modal',
      backModal: 'Back Modal',
      continueToCustomizer: 'Choose Size - Continue to Customize',
      navigateToCustomizer: 'Edit & Position Image',
      editImage: 'Edit & Position Image',
      reset: 'Reset',
      continue: 'Continue',
      customize: 'Customize',
    },
    redirectLabels: {
      footwear: "Add Your Image to a Shoe",
      apparel: "Add Your Image to Apparel and Accessories",
    },
    /**
     * @function logAnalyticsEvent
     * @description Adds an event to GTM's dataLayer.
     * These events are during the ugcEntryPoint workflow
     * but share the same formatting. This function is provided for the UGCEntryPoint
     * in order to avoid code duplication in the formatting of the GTM events.
     *
     * @param {object} payload
     * MUST have type attribute, to assure the dataLayer event type.
     * MUST have data attribute for selectStyle and selectSize to assure the dataLayer eventLabel.
     * @returns {void}
     */
    logAnalyticsEvent: function (payload) {
      let validEvent = true;

      const useEcomDataLayerFormat = $store.getters['utils/useEcomDataLayerFormat'];
      const canvasActive = $store.getters["utils/canvasActive"];
      const useCrayolaDataLayerFormat = $store.state.UGCEntryPoint.feature;
      const data = {
        event: useEcomDataLayerFormat ? this.event.nameIframe : this.event.name,
        eventCategory: this.event.category,
        eventAction: this.name[payload.action],
        eventLabel: payload.type
      };

      if (useEcomDataLayerFormat || useCrayolaDataLayerFormat) {
        data.nonInteractive = this.event.nonInteractive;
        data.customMetrics = payload.customMetrics || this.event.customMetrics;
        data.customVariables = payload.customMetrics || this.event.customVariables;
        data._clear = this.event._clear;
      }

      if (useCrayolaDataLayerFormat) {
        data.event = 'loadEventData';
      }

      if (payload.type === this.types.selectStyle && payload.isRedirect) {
          data.eventLabel = this.redirectLabels[payload.productType];
          data.eventAction += this.types.selectStyle;
      } else if (payload.type === this.types.selectStyle) {
          data.eventLabel = payload.data;
          data.eventAction += this.types.selectStyle;
      } else if (payload.type === this.types.selectSize && useCrayolaDataLayerFormat) {
        data.eventLabel = payload.data;
        data.eventAction += this.types.selectSize;

      } else if (payload.type === this.types.selectSize) {
        data.eventLabel = `${ payload.style }, ${ payload.data }`;
        data.eventAction += this.types.selectSize;
      } else if (typeof payload.type === 'undefined') {
        validEvent = false;
      }

      if (validEvent) {
        try {
          if(canvasActive) parent.dataLayer.push(data);
          else dataLayer.push(data)
        } catch (err) {
          console.error("CORS origin error on datalayer push to parent", err);
        }
      } else {
        console.warn('UGCEntryPoint: invalid data layer event: ', data);
      }
    },
    updateCategoryType: updateCategoryType,
  };
};
